import ProgressHeader from '../Components/Styled/ProgressHeader';
import { Col, Row, Typography } from 'antd';
import { Fragment, useEffect } from 'react';
import { useCustomer } from '../common/customerContext';
const { Title, Paragraph, Text } = Typography;

const Schedule = () => {
  const customer = useCustomer();

  return (
    <Fragment>
      <Row type="flex" justify="center">
        <ProgressHeader
          hasNav={true}
          showBackIcon={customer.campaignCode && !customer.cartId}
        />
        <Col xs={0} md={5} lg={6}></Col>
        <Col
          xs={24}
          md={14}
          lg={12}
          style={{ marginTop: '16px' }}
          className="padMobile"
        >
          <Typography>
            <Title level={2} style={{ textAlign: 'center' }}>
              Book a time for a quick 15 minute call to get your free estimate
              and review your plan.
            </Title>
            <Title level={5} style={{ textAlign: 'center' }}>
              Meet With Your Digs Team to Review Your Plan, Services and Pricing
            </Title>
          </Typography>
        </Col>
        <Col xs={0} md={5} lg={6}></Col>
        <Col xs={0} md={5} lg={6}></Col>
        <Col
          xs={24}
          md={14}
          lg={12}
          style={{ marginTop: '16px', marginBottom: '16px' }}
          className="padMobile"
        >
          <script
            src="https://www.cnvrsnly.com/js/form_embed.js"
            type="text/javascript"
          ></script>
          <iframe
            src="https://www.cnvrsnly.com/widget/booking/UbXMQ0h5Ofk3PahOFpnF"
            // style="width: 100%;border:none;overflow: hidden;"
            style={{
              width: '100%',
              height: 1600,
              border: 'none',
              overflow: 'hidden',
            }}
            scrolling="no"
            id="iCW4CrLmLWOtgzntSXLd_1734634942826"
          ></iframe>
          <br />
        </Col>
        <Col xs={0} md={5} lg={6}></Col>
      </Row>
    </Fragment>
  );
};

export default Schedule;
